<style>
.el-collapse-item__header {
  padding-left: 15px;
}

.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}

.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}

.v-modal {
  z-index: 100 !important;
}

.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}

.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}

.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}

.management-list {
  display: flex;
  align-items: center;
  /* margin-bottom: 15px; */
}

.select-department {
  color: green;
  text-decoration: underline;
  cursor: pointer;
}

.management-name {
  flex-shrink: 0;
}

.designee {
  padding: 3px 10px 6px 10px;
  display: inline-block;
  border: 1px solid grey;
  box-sizing: border-box;
  line-height: 20px;
  margin-right: 10px;
}

.input-item {
  display: flex;
  align-items: center;
  margin-left: 20px;
  margin-bottom: 25px;
}

.input-item .input-title {
  margin-right: 14px;
}

.add {
  text-align: left;
  color: #4fa1a4;
  text-decoration: underline;
  cursor: pointer;
}

.del {
  color: #4fa1a4;
  text-decoration: underline;
  cursor: pointer;
  margin-left: 10px;
}

.product-item {
  display: flex;
  margin-top: 10px;
}

.product {
  display: flex;
  align-items: center;
}

.product-img {
  width: 60px;
  height: 60px;
  margin-right: 15px;
}

.product-text {
  width: 130px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.reject-btn.btn {
  background: #FFF2F4;
  border: 1px solid rgba(255, 219, 224, 1);
  border-radius: 2px;
  color: #FB2323;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;

}

.pass-btn.btn {
  background: #F2FFF5;
  border: 1px solid rgba(220, 250, 228, 1);
  border-radius: 2px;
  color: #1BA854;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}

.ing-btn.btn {
  background: #FFFBF2;
  border: 1px solid rgba(255, 241, 212, 1);
  border-radius: 2px;
  color: #FF991C;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}

.cancel-btn.btn {
  background: #F5F5F5;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  color: #666;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}

.search-area-div {
  display: inline-block;
}
</style>
<template>
  <div class="content" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="tab-wrap">
      <el-tabs v-model="page.listType" @tab-click="filterFlow">
        <el-tab-pane label="全部流程" name="0"> </el-tab-pane>
        <el-tab-pane label="待处理" name="4"></el-tab-pane>
        <el-tab-pane label="已处理" name="2"></el-tab-pane>
        <el-tab-pane label="我收到的" name="3"></el-tab-pane>
        <el-tab-pane label="我发起的" name="1"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6">
          <div class="search-area-div">客户名称：</div>
          <el-input size="mini" v-model="page.tenantName" class="ipt-sty" placeholder="请输入客户名称"></el-input>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">立项人：</div>
          <el-select size="mini" v-model="page.createProjectStaffGuid" class="ipt-sty" placeholder="请选择立项人" filterable>
            <el-option v-for="item in staffList" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">审批状态：</div>
          <el-select size="mini" filterable clearable v-model="page.approveState" placeholder="请选择审批状态" class="ipt-sty">
            <el-option v-for="item in approveList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <div style="float: left" class="search-btn-box">
          <el-button size="mini" type="info" @click="search">搜索</el-button>
          <el-button size="mini" type="danger" @click="emptySearch">清空</el-button>
        </div>
      </el-row>
    </div>

    <div class="back-color-fff content-main-box" :style="'height:' + contentMainHeight + 'px;'">
      <div class="button-area">
        <el-button icon="el-icon-plus" size="mini" type="info" @click="addVersion">添加立项</el-button>
      </div>
      <el-table :height="height" :data="tableData" stripe border style="width: 100%" v-loading="tableLoading">
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="templateName" label="客户名称" show-overflow-tooltip header-align="center" align="left"
          width="180">
          <template slot-scope="scope">{{ scope.row.tenantName }}</template>
        </el-table-column>
        <el-table-column prop="taskTotal" label="公司类型" show-overflow-tooltip header-align="center" align="left">
          <template slot-scope="scope">{{ getName(scope.row.platformEnterpriseType, '平台企业类型') }}</template>
        </el-table-column>
        <el-table-column prop="templateName" label="立项人" show-overflow-tooltip header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.createProjectStaffName || '-' }}</template>
        </el-table-column>
        <el-table-column prop="createTime" label="立项时间" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.createProjectDate | getDate }}</template>
        </el-table-column>
        <el-table-column prop="taskTotal" label="项目类型" show-overflow-tooltip header-align="center" align="left">
          <template slot-scope="scope">{{ getName(scope.row.projectType, '合同内容分类') }}</template>
        </el-table-column>
        <el-table-column prop="createTime" label="审批状态" header-align="center" align="center">
          <template slot-scope="scope">
            <a class="reject-btn btn" v-if="scope.row.approveState == 'R'">已驳回</a>
            <a class="pass-btn btn" v-if="scope.row.approveState == 'Y'">已通过</a>
            <a class="ing-btn btn" v-if="scope.row.approveState == 'A'">审批中</a>
            <a class="cancel-btn btn" v-if="scope.row.approveState == 'N'">草稿中</a>
            <a class="cancel-btn btn" v-if="scope.row.approveState == 'C'">已撤销</a>
          </template>
        </el-table-column>
        <el-table-column prop="templateName" label="操作人" show-overflow-tooltip header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.updateUserName || '-' }}</template>
        </el-table-column>
        <el-table-column prop="createTime" label="操作时间" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.updateTime | getDate }}</template>
        </el-table-column>

        <el-table-column prop="bank" min-width="130px" label="操作" header-align="center" align="center" fixed="right">
          <template slot-scope="scope">
            <!-- 草稿中 -->
            <div v-if="scope.row.approveState == 'N'">
              <a class="txt-color" @click="editForm(scope.row)">编辑 ｜</a>
              <a class="txt-color" @click="delForm(scope.row.guid)">删除</a>
            </div>
            <!--已驳回 已撤销  -->
            <div v-if="scope.row.approveState == 'R' || scope.row.approveState == 'C'">
              <a class="txt-color" v-if="scope.row.staffGuid == staffGuid && scope.row.bizApproveState != 'D'"
                @click="editForm(scope.row)">重新提交｜</a>
              <a class="txt-color" v-else @click="seeForm(scope.row)">详情｜</a>
              <a class="txt-color"  v-if="scope.row.staffGuid == staffGuid" @click="delForm(scope.row.guid)">删除</a>

            </div>

            <!-- 已通过 -->
            <div v-if="scope.row.approveState == 'Y'">
              <a class="txt-color" @click="choosePerson(scope.row)">指定运营经理｜</a>
              <a class="txt-color" @click="seeForm(scope.row)">详情</a>
            </div>

            <!-- 审批中 -->
            <div v-if="scope.row.approveState == 'A'">
              <a class="txt-color" @click="choosePerson(scope.row)">指定运营经理｜</a>
              <a class="txt-color" v-if="scope.row.staffGuid == staffGuid" @click="toRevoke(scope.row)">撤销｜</a>
              <a class="txt-color" v-if="scope.row.approveStaffGuids.indexOf(staffGuid) > -1"
                @click="passDialogVisible = true; approveSuggest = ''; form = scope.row;">通过｜</a>
              <a class="txt-color" v-if="scope.row.approveStaffGuids.indexOf(staffGuid) > -1"
                @click="rejectDialogVisible = true; approveSuggest = ''; form = scope.row;">驳回｜</a>
              <a class="txt-color" @click="seeForm(scope.row)">详情</a>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination class="pt pb back-color-fff content-pagination-box" background @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :page-sizes="[10, 20, 50, 100, 200]" :current-page="page.pageIndex"
      :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page.totalRows">
    </el-pagination>
    <el-dialog title="驳回流程" :visible.sync="rejectDialogVisible" width="30%" top="15%">
      <el-input type="textarea" maxlength="100" :rows="5" placeholder="输入驳回理由（必填）" v-model="approveSuggest"> </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toRejectSubmit()">驳回</el-button>
      </span>
    </el-dialog>
    <el-dialog title="填写通过备注" :visible.sync="passDialogVisible" width="30%" top="15%">
      <el-input type="textarea" maxlength="100" :rows="5" placeholder="请填写通过备注（选填）" v-model="approveSuggest"> </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toPassSubmit()">通过</el-button>
      </span>
    </el-dialog>
    <ChoosePerson ref="choosePerson" staffType="1" @onSelect="onPersonSelect"></ChoosePerson>
  </div>
</template>

<script>
import ChoosePerson from '@/components/person/choosePerson';
export default {
  components: {
    ChoosePerson
  },
  data() {
    let userinfo = JSON.parse(localStorage.userInfo);
    return {
      height: window.innerHeight - 290,
      contentMainHeight: window.innerHeight - 200,
      fullscreenLoading: false,
      textTitle: '新增任务大类',
      organisationList: [],
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        createProjectStaffGuid: '',
        currentTenantGuid: localStorage.guid, //模版名称
        tenantName: '',
        approveState: null,
        listType: '0',
      },
      staffList: [],
      sendTenantList: [],
      tableData: [],
      staffGuid: userinfo.staffGuid,
      approveSuggest: '',
      passDialogVisible: false,
      rejectDialogVisible: false,
      form: '',

      approveList: [
        {
          label: '全部',
          value: null
        },
        {
          label: '草稿中',
          value: 'N'
        },
        {
          label: '审批中',
          value: 'A'
        },
        {
          label: '已通过',
          value: 'Y'
        },
        {
          label: '驳回',
          value: 'R'
        },
        {
          label: '已撤销',
          value: 'C'
        },
      ],
    };
  },
  created() {
    this.getList();
    this.getStaffList();
  },
  activated(){
    this.getList();
  },
  methods: {
    choosePerson(obj) {
      this.form = obj;
      this.$refs.choosePerson.open(this.form.projectManagerGuid ? [this.form.projectManagerGuid] : []);
    },
    onPersonSelect([personGuid, data, name]) {
      this.form.projectManagerGuid = personGuid && personGuid.length > 0 ? personGuid[0] : null;
      this.form.projectManagerName = name || null;
      if (!this.form.projectManagerGuid) return;
      this.fullscreenLoading = true;
      let req = {
        guid: this.form.guid,
        projectManagerName: this.form.projectManagerName,
        projectManagerGuid: this.form.projectManagerGuid,
        isConfigProjectManager:"Y",
      }
      this.api.postJson(`/${serverConfig.msCustomerService}/projectApply/update`, req).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.$message({
            message: '指定成功',
            type: 'success',
          });
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    getName(name, key) {
      let list = this.getCodeListByKey(key);
      let lisArr = list.filter(item => item.value == name);
      return lisArr.length ? lisArr[0].text : '-';
    },
    getStaffList() {
      let req = {
        tenantGuid: localStorage.guid,
        staffType: 1,
      }
      this.api.postJson(`/${serverConfig.msPersonnelService}/staff/get-select-staff`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          console.log(res.data.data)
          this.staffList = res.data.data;
        } else {
          this.$message.error(res.data.data.msg);
        }
      });
    },

    search() {
      let self = this;
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msCustomerService}/projectApply/list`, this.page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    emptySearch() {
      this.page = {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        createProjectStaffGuid: '',
        currentTenantGuid: localStorage.guid, //模版名称
        tenantName: '',
        approveState: null,
        listType:'0'
      };
      this.getList();
    },
    addVersion() {
      this.$router.push('/projectEdit?productGuid=' + this.$route.query.productGuid);
    },
    getList() {
      let self = this;
      let req = JSON.parse(JSON.stringify(this.page))
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msCustomerService}/projectApply/list`, req).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //删除
    delForm(guid) {
      var self = this;
      self
        .$confirm('删除后不可恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          self.api
            .postJson(`/${serverConfig.msCustomerService}/projectApply/delete`, [guid])
            .then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.$message.success('删除成功');
                self.page.pageIndex = 1;
                self.getList();
              } else {
                self.$message.error(res.data.msg);
              }
            });
        });
    },
    //编辑
    editForm(res) {
      this.$router.push({
        path: '/projectEdit',
        query: {
          productGuid: this.$route.query.productGuid,
          form: encodeURIComponent(JSON.stringify(res))

        }
      });
    },
    //详情
    seeForm(res) {
      this.$router.push({
        path: '/projectDetail',
        query: {
          form: encodeURIComponent(JSON.stringify(res)),
          productGuid: this.$route.query.productGuid
        }
      });
    },
    //驳回提交
    toRejectSubmit() {
      let userinfo = JSON.parse(localStorage.userInfo);
      if (this.approveSuggest == '') {
        this.$message.error('请填写驳回理由！');
        return;
      }
      let query = {
        guid: this.form.approveGuid,
        flowType: '00009',
        approveSuggest: this.approveSuggest,
        approveStaffGuid: userinfo.staffGuid
      };
      this.fullscreenLoading = true;

      this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/backup-flow`, query).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.rejectDialogVisible = false;
          this.$message.success('驳回成功！');
          this.getList();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //通过
    toPassSubmit() {
      let userinfo = JSON.parse(localStorage.userInfo);
      let query = {
        guid: this.form.approveGuid,
        flowType: '00009',
        approveSuggest: this.approveSuggest,
        approveStaffGuid: userinfo.staffGuid
      };
      this.fullscreenLoading = true;
      this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/allow-flow`, query).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.passDialogVisible = false;
          this.$message.success('审批通过！');
          this.getList();
        } else {
          this.$message.error(res.data.msg);
        }
      });

    },
    //撤回
    toRevoke(form) {
      let self = this;
      this.$confirm('确定撤销吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let query = {
          guid: form.approveGuid,
          flowType: '00009',
          approveStaffGuid: form.staffGuid
        };
        self.fullscreenLoading = true;
        self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/canal-flow`, query).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.fullscreenLoading = false;
            self.$message.success('撤销成功！');
            this.getList();
          } else {
            self.$message.error(res.data.msg);
          }
        });
      })
        .catch(() => {
          self.$message({
            type: 'info',
            message: '已取消操作！',
          });
        });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getList();
    },
    filterFlow(el) {
      this.getList();
    },
  },
};
</script> 
<style scoped>
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}

.el-range-editor.el-input__inner {
  padding: 0px;
}

/deep/ .el-checkbox__label {
  display: none;
}

.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}

.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}

/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}

/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}

/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}

/deep/ .el-col-6 {
  display: flex;
  word-break: keep-all
}

.tab-wrap {
  background: #fff;

}

/deep/ .el-tabs__nav {
  margin-left: 10px;
}

.search-area {
  padding-top: 0;
}</style>